import http from '@/plugins/axios';

export default {
  getThemes() {
    return http.get('/settings/themes').then(res => res.data);
  },
  finishOnboarding() {
    return http.post('/install-onboarding-finished').then(res => res.data);
  },
  updateOnboarding(payload) {
    return http.post('/update-onboarding-status', payload).then(res => res.data);
  },
  installWidgets(payload) {
    return http.post('/onboarding-widgets-install', payload).then(res => res.data);
  },
  uninstallWidgets(themeId) {
    return http.post(`/settings/themes/${themeId}/uninstall-widgets-only`).then(res => res.data);
  },
  checkOnboarding(themeId) {
    return http
      .get('/onboarding-post-install-check', { params: { themeId } })
      .then(res => res.data.data);
  },
  checkThemeInstallStatus: themeId => {
    // {
    //     "statuses": {
    //         "main_theme": main_theme,
    //         "password_protected": password_protected,  # we can't check automatically because shop is password protected
    //         "review_widget": review_widget,  # is review widget installed
    //         "product_stars": product_stars,  # are product stars installed
    //         "collection_stars": collection_stars,  # are collection stars installed
    //     },
    //     "theme_status": check_theme_status(shop_id, theme_id),
    //     "theme_files": theme_files,
    //     "product_page_url": product_page_url
    // }
    //
    return http
      .get(`/settings/themes/${themeId}/onboarding-install-status`)
      .then(response => response.data.data);
  },
  setShownWidgetInstallationMessage() {
    return http.post('/set-shown-widget-installation-message').then(res => res.data);
  },
};
